import { PaymentMethodInfo } from './payment-method-info';
import { isReusablePaymentMethodType } from './payment-method-type';
import { ReusablePaymentMethod } from './reusable-payment-method/reusable-payment-method';
import { isWalletPaymentMethod, WalletPaymentMethod } from './wallet-payment-method/wallet-payment-method';

export type PaymentMethod = ReusablePaymentMethod | WalletPaymentMethod;

export const isReusablePaymentMethod = (paymentMethod: PaymentMethod | PaymentMethodInfo): paymentMethod is ReusablePaymentMethod =>
  isReusablePaymentMethodType(paymentMethod.type);

export const isPaymentMethod = (paymentMethod: PaymentMethod | PaymentMethodInfo): paymentMethod is PaymentMethod =>
  isReusablePaymentMethod(paymentMethod) || isWalletPaymentMethod(paymentMethod);
